const CicleCheckIcon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        id="Ellipse 7"
        cx="13"
        cy="13"
        r="12"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};

export default CicleCheckIcon;
